import { render, staticRenderFns } from "./FlowChord.vue?vue&type=template&id=5ad28ef0&scoped=true&"
import script from "./FlowChord.vue?vue&type=script&lang=js&"
export * from "./FlowChord.vue?vue&type=script&lang=js&"
import style0 from "./FlowChord.vue?vue&type=style&index=0&id=5ad28ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad28ef0",
  null
  
)

export default component.exports